<div class="container" [style.background-color]="color">
  <fa-icon *ngIf="isActive" [icon]="faCheck"></fa-icon>
</div>
